import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Box, Divider, Typography } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import validator from 'validator';
import { ReactComponent as AdminButton } from '../../../assets/admin-button.svg';
import { ReactComponent as LogoutIcon } from '../../../assets/logout-red.svg';
import { ReactComponent as SettingIcon } from '../../../assets/settings.svg';
import { useInput } from '../../../customHook/useInput';
import RoutePaths from '../../../routes/RoutePaths';
import { AuthService } from '../../../service/auth.service';
import { HuddleService } from '../../../service/huddle.service';
import { SFService } from '../../../service/SF.service';
import { ZoomInfoService } from '../../../service/zoominfo.service';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { switchAdmin } from '../../../store/slices/dashboardSlice';
import zeplinColor from '../../../theme/Color';
import { Utilities } from '../../../utilities/utilities';
import CustomAutocomplete from '../CustomAutocomplete/CustomAutocomplete';
import CustomCard from '../CustomCard/CustomCard';
import CustomModal from '../CustomModal/CustomModal';
import CustomPopOver from '../CustomPopOver/CustomPopOver';
import styles from './Header.module.css';
import Settings from './Settings/Settings';
import { setOpenAddLeadDrawer } from 'store/slices/leadsSlice';

const Header = () => {
  const wait = useRef<any>(null);
  const dispatch = useAppDispatch();
  const userName = sessionStorage.getItem('user-name') || '';
  const userEmail = sessionStorage.getItem('current-user') || '';
  const location = useLocation();
  const adminConsole = useAppSelector((state) => state.dashboard.adminConsole);
  const { role } = useAppSelector((state) => state.auth);
  const locationName = location.pathname.split('/').at(-1);
  const headerLabel =
    location.pathname === '/leads/new-lead/social-insights'
      ? 'Social Insights'
      : location.pathname === '/dashboard/admin' && adminConsole
        ? 'Admin Console'
        : Utilities.toCamelCase(locationName ? locationName : '');
  const details = location.pathname?.split('/');
  const linkInputRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const [selectedSettings, setSelectedSettings] = useState('Profile');
  const [anchorEl, setAnchorEl] = React.useState<HTMLDivElement | null>(null);
  const [searchZoomInfo, setSearchZoominfo] = useState<any[]>([]);
  const [searchValue, setSearchValue] = useState('');
  const [total, setTotal] = useState(0);
  const [openSettingsModal, setOpenSettingsModal] = React.useState(false);
  const [linkField, setLinkField] = React.useState(false);
  const [profileLoader, setProfileLoader] = React.useState(false);
  const [linkLoader, setLinkLoader] = React.useState(false);
  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const [anchorElLink, setAnchorElLink] = React.useState<HTMLDivElement | null>(null);
  const customLinkIdx = useRef<number | null>(null);

  const handleClickLink = (
    event: React.MouseEvent<HTMLDivElement>,
    type:
      | 'customLink'
      | 'facebook_profile_url'
      | 'instagram_profile_url'
      | 'twitter_profile_url'
      | 'linkedin_profile_url',
    edit = false,
    element = 0,
  ) => {
    if (linkField) {
      setLinkField((prev) => !prev);
      setLink('');
      setLinkPost({ customLink: '' });
    } else if (!linkField && (event.target as HTMLDivElement).getAttribute('alt') === 'option') {
      setLinkField(true);
      handleLinkField(type, edit, element);
    }
    customLinkIdx.current = type === 'customLink' ? element : null;

    setTimeout(() => {
      if (linkInputRef?.current) {
        linkInputRef.current.scrollTop = linkInputRef.current.scrollHeight;
      }
    }, 0);
  };

  const handleDeleteCustomLink = async () => {
    try {
      setAnchorElLink(null);
      setLinkLoader(true);
      if (customLinkIdx?.current !== null) {
        await HuddleService.saveProfile(userEmail, {
          customLink: profile?.customLink.filter((val, ind) => ind !== customLinkIdx?.current),
        });
      }
      customLinkIdx.current = null;
      setLink('');
      setLinkPost({ customLink: '' });
      setAlert('Custom link removed successfully');
    } catch (err) {
      setAlert('Something went wrong');
    } finally {
      setLinkLoader(false);
    }
  };
  const openLink = Boolean(anchorElLink);
  const idLink = openLink ? 'simple-popover' : undefined;

  const [alert, setAlert] = React.useState('');
  const token = sessionStorage.getItem('user-token') || '';
  const isMSLogin = sessionStorage.getItem('ms_login') || '';
  let accessToken: any = {};
  if (token) {
    accessToken = JSON.parse(token);
  }
  const [openModal, setOpenModal] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [profile, setProfile] = React.useState<{
    Address: {
      city: string;
      country: string;
      geocodeAccuracy: string;
      latitude: string;
      longitude: string;
      postalCode: string;
      state: string;
      street: string;
    };
    Email: string;
    MobilePhone: string;
    Name: string;
    Phone: string;
    Role: string;
    SF_Profile_URL: string;
    facebook_profile_url: string;
    instagram_profile_url: string;
    profile_image_url: string;
    twitter_profile_url: string;
    linkedin_profile_url: string;
    customLink: [string];
  }>({
    Address: {
      city: '',
      country: '',
      geocodeAccuracy: '',
      latitude: '',
      longitude: '',
      postalCode: '',
      state: '',
      street: '',
    },
    Email: '',
    MobilePhone: '',
    Name: '',
    Phone: '',
    Role: '',
    SF_Profile_URL: '',
    facebook_profile_url: '',
    instagram_profile_url: '',
    profile_image_url: '',
    twitter_profile_url: '',
    linkedin_profile_url: '',
    customLink: [''],
  });

  const handleOpen = () => {
    setOpenModal(true);
    setAnchorEl(null);
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  const signOut = async () => {
    setLoading(true);
    try {
      const res = await AuthService.logout({
        accessToken: accessToken?.AccessToken,
        isMSLogin: isMSLogin ? true : false,
      });

      if (res?.microsoftLogoutUrl) {
        sessionStorage.clear();

        window.location.href = res?.microsoftLogoutUrl;
      } else {
        sessionStorage.removeItem('loginExpiry');
        sessionStorage.removeItem('sf_path');
        sessionStorage.removeItem('refreshToken');
        sessionStorage.removeItem('user-name');
        sessionStorage.removeItem('user-token');

        sessionStorage.removeItem('currentTab');
        navigate(RoutePaths.Root);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const getProfileDetails = async () => {
    try {
      setLoading(true);
      const res = await SFService.getProfileDetails(userEmail);
      setProfile(res);
    } catch (err: any) {
      setAlert('Something went wrong!');
    } finally {
      setLoading(false);
    }
  };

  const handleOpenSettings = () => {
    setAnchorEl(null);
    setOpenSettingsModal(true);
  };

  const handleCloseSettings = () => {
    setOpenSettingsModal(false);
    setLinkField(false);
    clearLink();
  };

  useEffect(() => {
    if (!profileLoader || !linkLoader) {
      getProfileDetails();
    }
  }, [profileLoader, linkLoader]);

  const openInput = () => {
    window.document.getElementById('attachment')?.click();
  };

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    setProfileLoader(true);
    try {
      if (event.target.files) {
        await SFService.getPresigned(
          userEmail,
          event.target.files[0]?.type,
          event.target.files[0]?.name,
        );
      }
      setAlert('Profile changed successfully');
    } catch (err: any) {
      console.log(err);
      setAlert('Something went wrong!');
    } finally {
      setProfileLoader(false);
    }
  };

  const handleRemoveDp = async () => {
    try {
      setProfileLoader(true);
      setAlert('User profile successfully removed.');
    } catch (err) {
      setAlert('Something went wrong.');
    } finally {
      setProfileLoader(false);
    }
  };

  const [linkPost, setLinkPost] = useState<
    | { customLink: string }
    | { facebook_profile_url: string }
    | {
        instagram_profile_url: string;
      }
    | { twitter_profile_url: string }
    | { linkedin_profile_url: string }
  >({ customLink: '' });

  const {
    handleChange: handleLinkChange,
    handleBlur: handleLinkBlur,
    clearInput: clearLink,
    value: link,
    invalid: invalidLink,
    didChange: didLinkChange,
    setValue: setLink,
  } = useInput(
    linkPost[Object.keys(linkPost)[0] as keyof typeof linkPost]
      ? linkPost[Object.keys(linkPost)[0] as keyof typeof linkPost]
      : '',
    validator?.isURL,
  );

  const handleLinkField = (
    type:
      | 'customLink'
      | 'facebook_profile_url'
      | 'instagram_profile_url'
      | 'twitter_profile_url'
      | 'linkedin_profile_url',
    edit = false,
    element = 0,
  ) => {
    if (type === 'customLink') {
      if (edit) {
        setLinkPost({ customLink: profile?.customLink[element] });
        setLink(profile?.customLink[element]);
      } else {
        setLinkPost({ customLink: '' });
      }
    } else {
      setLink(profile[type as keyof typeof profile] as string);
      setLinkPost({
        [type]: profile[type as keyof typeof profile] ? profile[type as keyof typeof profile] : '',
      } as
        | { customLink: string }
        | { facebook_profile_url: string }
        | { instagram_profile_url: string }
        | { twitter_profile_url: string }
        | { linkedin_profile_url: string });
    }
  };

  const suggestionZoominfoAPI = async (value: string) => {
    try {
      const res = await ZoomInfoService.searchZoominfo(value);

      setSearchZoominfo([
        ...res?.categories?.companies?.items.map((val: any) => ({
          ...val,
          group: 'Companies',
          label: val.name,
          Id: val?.id,
          Name: val?.name,
          avatar: val?.logo,
          followers: val?.website,
        })),
        ...res?.categories?.contacts?.items.map((val: any) => ({
          ...val,
          group: 'Contacts',
          label: val.name,
          Id: val?.id,
          Name: val?.name,
          avatar: val?.logo,
          followers: val?.website,
        })),
      ]);
      setTotal(res?.total);
      setSearchValue(value);
    } catch (err) {
      setAlert('Something went wrong');
    }
  };

  const handleSearch = async (e: React.SyntheticEvent, value: string) => {
    clearTimeout(wait.current);
    if (value) {
      const getSuggestion = setTimeout(() => suggestionZoominfoAPI(value), 1000);
      wait.current = getSuggestion;
    }
  };

  useEffect(() => {
    setLinkPost(
      (prev) =>
        ({ [Object.keys(prev)[0]]: link }) as
          | { customLink: string }
          | { facebook_profile_url: string }
          | { instagram_profile_url: string }
          | { twitter_profile_url: string }
          | { linkedin_profile_url: string },
    );
  }, [link]);

  const handleSave = async () => {
    try {
      setLinkLoader(true);
      if (Object.keys(linkPost)[0] === 'customLink') {
        await HuddleService.saveProfile(userEmail, {
          customLink:
            Array.isArray(profile?.customLink) &&
            customLinkIdx?.current === null &&
            profile?.customLink?.length
              ? [...profile?.customLink, Object.values(linkPost)[0]]
              : Array.isArray(profile?.customLink) && profile?.customLink?.length
                ? [
                    ...profile?.customLink?.map((val, ind) =>
                      ind === customLinkIdx?.current ? Object.values(linkPost)[0] : val ? val : '',
                    ),
                  ]
                : Array.isArray(profile?.customLink) && !profile?.customLink?.length
                  ? [Object.values(linkPost)[0]]
                  : [profile?.customLink, Object.values(linkPost)[0]],
        });
        customLinkIdx.current = null;
        setLinkField(false);
        setAlert('Link successfully saved');
        setLinkPost({ customLink: '' });
        setLink('');
      } else {
        await HuddleService.saveProfile(userEmail, {
          ...linkPost,
        });
        setLinkField(false);
        setAlert('Link successfully saved');
      }
    } catch (err: any) {
      setAlert('Something went wrong');
    } finally {
      clearLink();
      setLinkLoader(false);
    }
  };

  const linkValue = linkPost[Object.keys(linkPost)[0] as keyof typeof linkPost] as string;
  const isAdminRolePermission = details.includes('admin') && details.length > 3;

  const isDetailPage = details.length > 2 && !details.includes('admin');

  const isSocialInsights = location.pathname === '/leads/new-lead/social-insights';

  const sectionLabel =
    details[1] === 'asana'
      ? 'Projects'
      : `${details[1]?.charAt(0).toUpperCase()}${details[1]?.slice(1)}`;

  const detailLabel =
    details[1] === 'asana'
      ? 'Project Detail'
      : details[1] === 'team'
        ? 'Member Detail'
        : `${details[1]?.charAt(0).toUpperCase()}${details[1]?.slice(
            1,
            details[1] === 'clients' ? details[1].length - 1 : details[1].length,
          )} Detail`;

  const handleGoBack = () => {
    if (isSocialInsights) {
      dispatch(setOpenAddLeadDrawer(true));
      navigate('/leads');
    } else {
      sessionStorage.removeItem('currentTab');
      navigate(-1);
    }
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: { xs: '12px 16px', xl: '16px 24px' },
          alignItems: 'center',
        }}
      >
        {isSocialInsights || isDetailPage ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, alignItems: 'flex-start' }}>
            <Box sx={{ display: 'flex', gap: '1px' }}>
              <Typography variant='label2' color={zeplinColor.Neutral8}>
                {sectionLabel}/
              </Typography>
              <Typography variant='label2'>
                {isSocialInsights ? 'Social Insights' : detailLabel}
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginLeft: '-8px',
                gap: '10px',
              }}
            >
              <img
                src={`/assets/back-icon.svg`}
                width='24px'
                height='24px'
                onClick={handleGoBack}
                style={{ cursor: 'pointer' }}
                alt='back-icon'
              />
              <Typography variant='responsiveHeading1'>
                {isSocialInsights ? 'Social Insights' : detailLabel}
              </Typography>
            </Box>
          </Box>
        ) : isAdminRolePermission ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, alignItems: 'flex-start' }}>
            <Box sx={{ display: 'flex', gap: '1px' }}>
              <Typography variant='label2' color={zeplinColor.Neutral8}>
                Admin Console/
              </Typography>
              <Typography variant='label2'>Role Permission</Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginLeft: '-8px',
                gap: '10px',
              }}
            >
              <img
                src={`/assets/back-icon.svg`}
                width='24px'
                height='24px'
                onClick={handleGoBack}
                style={{ cursor: 'pointer' }}
                alt='back-icon'
              />
              <Typography variant='responsiveHeading1'>Role Permission</Typography>
            </Box>
          </Box>
        ) : (
          <Typography variant='responsiveHeading1' sx={{ flex: 1, alignItems: 'flex-start' }}>
            {details[1] === 'Asana' ? 'Project' : headerLabel}
          </Typography>
        )}
        {location?.pathname?.includes('/zoominfo') && (
          <Box sx={{ flex: 2 }}>
            <CustomAutocomplete
              loading={loading}
              groupBy={true}
              searchIcon='/assets/Search.svg'
              required={false}
              fallback='/assets/zoominfo-fallback.svg'
              options={searchZoomInfo || []}
              getOptionLabel={(option: any) => (option?.Name ? option?.Name : '')}
              label={'Search for companies, contacts, industries, etc.'}
              handleDeleteItems={() => {}}
              selectedItems={[]}
              handleSelection={(value) => {
                navigate(`/zoominfo/${value?.Id}`);
              }}
              value={''}
              handleFilter={handleSearch}
              placeholder='Search for companies, contacts, industries, etc.'
              currentLength={searchZoomInfo?.length}
              totalLength={total}
              next={() => {
                suggestionZoominfoAPI(searchValue);
              }}
              multiple={false}
              inputBorder={50}
              outlineInputPadding={'5px'}
              key={location?.pathname || ''}
            />
          </Box>
        )}
        <Box
          sx={{
            display: 'flex',
            gap: '16px',
            flex: 1,
            justifyContent: 'flex-end',
            alignItems: 'center',
          }}
        >
          {role !== 'system-user' && (
            <Box
              sx={{
                width: '48px',
                height: '48px',
                borderRadius: '50px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: adminConsole ? zeplinColor.Neutral3 : 'transparent',
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: adminConsole ? zeplinColor.Neutral5 : zeplinColor.Neutral3,
                },
              }}
            >
              <AdminButton
                width='24px'
                height='24px'
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  adminConsole ? navigate(RoutePaths.Home) : navigate(RoutePaths.Home + '/admin');
                  dispatch(switchAdmin());
                }}
              />
            </Box>
          )}

          <Box
            sx={{
              height: 48,
              borderRadius: 50,
              backgroundColor: zeplinColor.Neutral3,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: '16px',
              padding: '6px',
              cursor: 'pointer',
            }}
            onClick={handleClick}
          >
            <Box
              sx={{
                height: 48,
                borderRadius: 50,
                backgroundColor: zeplinColor.Neutral3,
                display: 'flex',

                alignItems: 'center',
                gap: '8px',
                padding: '6px',
              }}
            >
              <Box
                sx={{
                  borderRadius: '100px',
                  padding: '10px',
                  width: { xs: '30px', xl: '36px' },
                  height: { xs: '30px', xl: '36px' },
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  backgroundColor: profile?.profile_image_url ? 'transparent' : zeplinColor.Brand1,
                }}
              >
                {profile?.profile_image_url ? (
                  <img
                    className={styles['profile-img']}
                    src={profile?.profile_image_url}
                    alt='profile-img'
                    style={{ borderRadius: '100px', objectFit: 'fill' }}
                  />
                ) : (
                  <Typography variant='responsiveLabel1' color={zeplinColor.Neutral1}>
                    {userName
                      ?.split(' ')
                      .map((value: any, index: number) =>
                        userName && (index === 0 || index === userName?.split(' ').length - 1)
                          ? value[0]
                          : '',
                      )}
                  </Typography>
                )}
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                }}
              >
                <Typography variant='responsiveBody3' color={zeplinColor.BasicBlack}>
                  {userName}
                </Typography>
                <Typography variant='responsiveCaption' color={zeplinColor.Neutral8}>
                  {profile?.Role}
                </Typography>
              </Box>
            </Box>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </Box>
        </Box>

        <CustomPopOver
          setAnchorEl={setAnchorEl}
          anchorEl={anchorEl}
          id={id}
          sx={{
            borderRadius: '14px',
            boxShadow: 'rgba(0, 0, 0, 0.15)',
            marginTop: '8px',
            marginRight: '0rem',
            zIndex: 999,
          }}
        >
          <Box
            sx={{
              paddingTop: '24px',
              width: '210px',
              height: '192px',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Box
              sx={{
                display: 'flex',

                alignItems: 'center',
                gap: '8px',
                padding: '0px 16px',
                cursor: 'pointer',
              }}
            >
              <Box
                sx={{
                  borderRadius: '100px',
                  padding: '10px',
                  width: '36px',
                  height: '36px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  backgroundColor: profile?.profile_image_url ? 'transparent' : zeplinColor.Brand1,
                }}
              >
                {profile?.profile_image_url ? (
                  <img
                    width={'36px'}
                    height={'36px'}
                    src={profile?.profile_image_url}
                    alt='profile-img'
                    style={{ borderRadius: '100px', objectFit: 'fill' }}
                  />
                ) : (
                  <Typography variant='label1' color={zeplinColor.Neutral1}>
                    {userName
                      ?.split(' ')
                      .map((value: any, index: number) =>
                        userName && (index === 0 || index === userName?.split(' ').length - 1)
                          ? value[0]
                          : '',
                      )}
                  </Typography>
                )}
              </Box>

              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                }}
              >
                <Typography variant='body3' color={zeplinColor.BasicBlack}>
                  {userName}
                </Typography>
                <Typography variant='caption' color={zeplinColor.Neutral8}>
                  {profile?.Role}
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                padding: '8px 0px',

                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
              }}
            >
              {' '}
              <Box
                sx={{
                  display: 'flex',
                  cursor: 'pointer',
                  gap: '16px',
                  padding: '16px',
                }}
                onClick={handleOpenSettings}
              >
                <SettingIcon width='18px' height='18px' />
                <Typography variant='body3' color={zeplinColor.BasicBlack}>
                  Settings
                </Typography>
              </Box>
              <Divider component='div' sx={{ borderColor: zeplinColor.Neutral5 }} />
              <Box
                sx={{
                  display: 'flex',
                  cursor: 'pointer',
                  gap: '16px',
                  padding: '16px',
                }}
                onClick={handleOpen}
              >
                <LogoutIcon width='18px' height='18px' />
                <Typography variant='body3' color={zeplinColor.Error}>
                  Logout
                </Typography>
              </Box>
            </Box>
          </Box>
        </CustomPopOver>
        <CustomModal handleClose={handleClose} open={openModal}>
          <Box
            sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}
          >
            <CustomCard
              styles={{
                borderRadius: '14px',
                padding: '24px',
                backgroundColor: zeplinColor.Neutral1,

                width: '312px',
                height: '183px',
                boxShadow: 'rgba(0, 0, 0, 0.15)',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%',
                  gap: '32px',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '16px',
                  }}
                >
                  <Typography variant='heading3' color={zeplinColor.BasicBlack}>
                    Log Out?
                  </Typography>
                  <Typography variant='body3' color={zeplinColor.BasicBlack}>
                    Are you sure you want to log out?
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '100%',
                    gap: '16px',
                  }}
                >
                  <Box onClick={handleClose}>
                    <CustomCard
                      styles={{
                        borderRadius: '14px',
                        padding: '14px 32px',
                        backgroundColor: zeplinColor.Neutral1,
                        border: `1px solid ${zeplinColor.BasicBlack}`,
                        cursor: 'pointer',
                      }}
                      aria-label='button'
                      aria-disabled={loading}
                    >
                      <Typography variant='buttonMedium' color={zeplinColor.BasicBlack}>
                        Cancel
                      </Typography>
                    </CustomCard>
                  </Box>
                  <Box onClick={signOut} sx={{ flex: 1 }}>
                    <CustomCard
                      styles={{
                        borderRadius: '14px',
                        padding: '14px 16px',
                        backgroundColor: zeplinColor.BasicBlack,
                        cursor: 'pointer',
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        minWidth: '120px',
                      }}
                      aria-label='button'
                      aria-disabled={loading}
                    >
                      <Typography
                        variant='buttonMedium'
                        color={zeplinColor.Neutral1}
                        sx={{
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          textAlign: 'center',
                          width: '100%',
                        }}
                      >
                        {loading ? 'Logging out' : 'Log Out'}
                      </Typography>
                    </CustomCard>
                  </Box>
                </Box>
              </Box>
            </CustomCard>
          </Box>
        </CustomModal>
        <Settings
          handleCloseSettings={handleCloseSettings}
          openSettingsModal={openSettingsModal}
          setLinkField={setLinkField}
          clearLink={clearLink}
          setOpenSettingsModal={setOpenSettingsModal}
          setSelectedSettings={setSelectedSettings}
          selectedSettings={selectedSettings}
          linkInputRef={linkInputRef}
          profile={profile}
          profileLoader={profileLoader}
          handleFileChange={handleFileChange}
          openInput={openInput}
          loading={loading}
          handleRemoveDp={handleRemoveDp}
          handleClickLink={handleClickLink}
          linkField={linkField}
          handleLinkBlur={handleLinkBlur}
          handleLinkChange={handleLinkChange}
          link={link}
          invalidLink={invalidLink}
          didLinkChange={didLinkChange}
          linkLoader={linkLoader}
          linkPost={linkPost}
          handleSave={handleSave}
          customLinkIdx={customLinkIdx}
          linkValue={linkValue}
          setLink={setLink}
          setLinkPost={setLinkPost}
          setAnchorElLink={setAnchorElLink}
          anchorElLink={anchorElLink}
          idLink={idLink}
          handleDeleteCustomLink={handleDeleteCustomLink}
          userEmail={userEmail}
          alert={alert}
          setAlert={setAlert}
          handleLinkField={handleLinkField}
        />
      </Box>
      <Divider component='div' sx={{ borderColor: zeplinColor.Neutral5, position: 'relative' }} />
    </>
  );
};

export default Header;
